export const tutorialsSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "@id": "/knowledge/video-tutorials#tutorials",
  "itemListElement": [
    {
      "@type": "VideoObject",
      "name": "Platform Overview",
      "description": "Learn how to use Scienza Health's cognitive health platform",
      "thumbnailUrl": "/mcai_social_preview.png",
      "uploadDate": "2024-03-20T08:00:00+00:00",
      "contentUrl": "/knowledge/video-tutorials",
      "embedUrl": "/knowledge/video-tutorials",
      "url": "/knowledge/video-tutorials"
    },
    {
      "@type": "VideoObject", 
      "name": "Getting Started Guide",
      "description": "Quick start guide for new users",
      "thumbnailUrl": "/mcai_social_preview.png",
      "uploadDate": "2024-03-20T08:00:00+00:00",
      "contentUrl": "/knowledge/video-tutorials",
      "embedUrl": "/knowledge/video-tutorials",
      "url": "/knowledge/video-tutorials"
    }
  ]
};